import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AudioPlayerState {
  url: string;
  isPlaying: boolean;
  activeInstance: string;
  persistentPlayerVisible: boolean;
}

const initialState: AudioPlayerState = {
  url: '',
  isPlaying: false,
  activeInstance: '',
  persistentPlayerVisible: false,
};

export const AudioPlayerSlice = createSlice({
  name: 'audioPlayer',
  initialState: initialState,
  reducers: {
    setURL: (state, action: PayloadAction<string>) => {
      state.url = action.payload;
    },
    setPlaying: (state, action: PayloadAction<boolean>) => {
      state.isPlaying = action.payload;
    },
    setActiveInstance: (state, action: PayloadAction<string>) => {
      state.activeInstance = action.payload;
    },
    setPersistentPlayerVisible: (state, action: PayloadAction<boolean>) => {
      state.persistentPlayerVisible = action.payload;
    },
  },
});

export const {
  setURL,
  setPlaying,
  setActiveInstance,
  setPersistentPlayerVisible,
} = AudioPlayerSlice.actions;

export default AudioPlayerSlice.reducer;
